import { render, staticRenderFns } from "./DonutChart65.vue?vue&type=template&id=266549ae&scoped=true"
import script from "./DonutChart65.vue?vue&type=script&lang=js"
export * from "./DonutChart65.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266549ae",
  null
  
)

export default component.exports